'use strict';

import '../../css/components/main-search-bar.scss';
import { EVENT_AUTOCOMPLETE_SELECT } from "../Shared/Autocomplete/Autocomplete";
import { mainSearchBarElements } from "./elements/mainSearchBarElements";
import Base from "../Shared/Base";

export const EVENT_SEARCH_SUBMIT = 'event_search_submit';

export default class MainSearchBar extends Base
{
    constructor(
        addressInput,
        catTagInput
    ) {
        super();
        this.catTagInput = catTagInput;
        this.addressInput = addressInput;

        this.elements = mainSearchBarElements();
        this.catTagInputChange = this.onCatTagInputChange.bind(this);
        this.addressInputChange = this.onAddressInputChange.bind(this);
        this.searchSubmit = this.onSearchSubmit.bind(this);

        this.addEventListeners();
    }

    addEventListeners() {
        this.catTagInput.addEventListener(EVENT_AUTOCOMPLETE_SELECT, this.catTagInputChange);
        this.addressInput.addEventListener(EVENT_AUTOCOMPLETE_SELECT, this.addressInputChange);
        this.elements.mainSearch.addEventListener('submit', this.searchSubmit);
    }

    onCatTagInputChange(event) {
        // console.log(event.detail);
    }

    onAddressInputChange(event) {
        // this.elements.bboxInput.value = event.detail.original.boundingbox;
        // this.elements.latInput.value = event.detail.original.lat;
        // this.elements.lngInput.value = event.detail.original.lon;
    }

    setWhat(what) {
        this.elements.whatInput.value = what;
        this.onSearchSubmit({preventDefault: () => {}});
    }

    onSearchSubmit(event) {
        event.preventDefault();
        this.dispatchEvent(new CustomEvent(
            EVENT_SEARCH_SUBMIT,
            {
                detail: {
                    what: this.elements.whatInput.value,
                    where: this.elements.whereInput.value,
                    distance: this.elements.distanceInput.value,
                    bbox: '', // this.elements.whereInput.value !== '' ? this.elements.bboxInput.value : '',
                    lat: '', // this.elements.whereInput.value !== '' ? this.elements.latInput.value : '',
                    lng: '', // this.elements.whereInput.value !== '' ? this.elements.lngInput.value : ''
                    paymentMethod: this.elements.paymentMethodInput.value
                }
            }
        ));
    }
}